// getLiveStreamChats.js
'use strict';
import { LIVESTREAM_CHAT_LIST_LIMITATION } from '../RemoteConfigKeys.js';

import createCachedSelector from '../resource/createCachedSelector.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getListData from '../selector/getListData.js';

const defaultList = [];
const defaultMap = {};

/**
 * Select live stream chat by stream id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} streamId - stream id.
 * @return {array} The selected live stream chat.
 */
const getLiveStreamChats = createCachedSelector(
  (state, streamId) =>
    getListData(state, ['liveStream', streamId, 'chat'], 'itemIds'),
  (state, streamId) => getLiveStreamData(state, [streamId], 'chat'),
  state => getRemoteConfigData(state, LIVESTREAM_CHAT_LIST_LIMITATION),
  (chatIds = defaultList, chatMap = defaultMap, max) => {
    return chatIds
      .slice(-max || 0)
      .map(id => chatMap[id])
      .filter(chat => chat != null);
  }
)((state, streamId) => `${streamId}`);

export default getLiveStreamChats;
